import React from 'react';
import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledChip = styled(Chip)(({ theme, status }) => {
  let color = '';
  let background = '';
  if (status === 'rejected' || status === 'error') {
    color = '#fff';
    background = '#e53935'; // Material UI error red
  }

  const statusColors = {
    pending: {
      bgcolor: '#1a202c', // Much darker for readability
      color: '#ffffff', // Pure white text
      fontWeight: 700
    },
    approved: {
      bgcolor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },
    rejected: {
      bgcolor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    },
    open: {
      bgcolor: '#1a202c', // Dark background for readability
      color: '#ffffff', // White text
      fontWeight: 700
    },
    closed: {
      bgcolor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    },
    upcoming: {
      bgcolor: '#1a202c', // Dark background for readability
      color: '#ffffff', // White text
      fontWeight: 700
    },
    unavailable: {
      bgcolor: '#708090', // Slate Gray
      color: theme.palette.text.primary
    },
    ineligible: {
      bgcolor: '#CD5C5C', // Indian Red
      color: theme.palette.common.white
    },
    voted: {
      bgcolor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },
    primary: {
      bgcolor: '#009999', // Prominent teal for "Voting Open"
      color: '#ffffff',
      fontWeight: 600,
      fontSize: '0.875rem'
    }
  };

  const colorSet = statusColors[status] || {
    bgcolor: theme.palette.info.main,
    color: theme.palette.info.contrastText
  };

  return {
    backgroundColor: '#009999 !important', // Strong teal
    color: '#fff !important', // Pure white text
    fontWeight: 700,
    borderRadius: '10px',
    padding: '0 10px',
    boxShadow: '0 2px 10px rgba(0,153,153,0.15)',
    letterSpacing: '0.03em',
    fontSize: '0.93rem',
    textTransform: 'none',
    lineHeight: 1.2,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '28px',
    '& .MuiChip-label': {
      padding: '4px 8px',
      color: '#fff !important',
      fontWeight: 700,
    },
  };

});

const StatusChip = ({ status, label, ...props }) => {
  const displayLabel = label || (
    status.charAt(0).toUpperCase() + status.slice(1)
  );
  
  return (
    <StyledChip status={status} label={displayLabel} size="small" {...props} />
  );
};

export default StatusChip;
